// src/modules/app-views/dataSearch/pages/Document/actions/actionButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************

// *******************************************************************************
// CONSTANTS
// *******************************************************************************

// *******************************************************************************
// MAIN FUNCTION
// *******************************************************************************
const dataSearchDocumentActionButton = () => {
  return {
    action: 'save',
    hideButton: false,
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default dataSearchDocumentActionButton;

// *******************************************************************************
// HELPERS
// *******************************************************************************
